import { createAsyncThunk } from "@reduxjs/toolkit";
import type {
  GetTemplatesByEventTypeRequest,
  GetTemplatesByEventTypeResponse,
  GetTemplateByIdResponse,
  SaveTemplateRequest,
  SaveTemplateResponse,
} from "../../models/template.model";
import { environment } from "../../environments";

const API_BASE_URL = environment.apiUrl;

/** שליפת תבניות לפי סוג אירוע */
export const getTemplatesByEventType = createAsyncThunk<
  GetTemplatesByEventTypeResponse,
  GetTemplatesByEventTypeRequest,
  { rejectValue: string }
>(
  "template/GetTemplatesByEventType",
  async (requestData, { rejectWithValue }) => {
    try {
      const response = await fetch(
        `${API_BASE_URL}Template/GetTemplatesByEventType`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(requestData),
        },
      );

      if (!response.ok) throw new Error(`HTTP ${response.status}`);
      const data: GetTemplatesByEventTypeResponse = await response.json();

      if (!data.success)
        return rejectWithValue(data.message || "Failed to fetch templates");
      return data;
    } catch (error) {
      return rejectWithValue(
        error instanceof Error ? error.message : "Unknown error",
      );
    }
  },
);

/** שליפת תבנית לפי ID */
export const getTemplateById = createAsyncThunk<
  GetTemplateByIdResponse,
  number,
  { rejectValue: string }
>(
  "template/GetTemplateById",
  async (templateId, { rejectWithValue }) => {
    try {
      const response = await fetch(
        `${API_BASE_URL}Template/GetTemplateById/${templateId}`,
      );

      if (!response.ok) throw new Error(`HTTP ${response.status}`);
      const data: GetTemplateByIdResponse = await response.json();

      if (!data.success)
        return rejectWithValue(data.message || "Failed to fetch template");
      return data;
    } catch (error) {
      return rejectWithValue(
        error instanceof Error ? error.message : "Unknown error",
      );
    }
  },
);

/** שמירת תבנית (יוצר או מעדכן) */
export const saveTemplate = createAsyncThunk<
  SaveTemplateResponse,
  SaveTemplateRequest,
  { rejectValue: string }
>(
  "template/SaveTemplate",
  async (requestData, { rejectWithValue }) => {
    try {
      const response = await fetch(
        `${API_BASE_URL}Template/SaveTemplate`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(requestData),
        },
      );

      if (!response.ok) throw new Error(`HTTP ${response.status}`);
      const data: SaveTemplateResponse = await response.json();

      if (!data.success)
        return rejectWithValue(data.message || "Failed to save template");
      return data;
    } catch (error) {
      return rejectWithValue(
        error instanceof Error ? error.message : "Unknown error",
      );
    }
  },
);
